import { pathsEqual } from "@pathwright/utils"

/** Router state key for the modal close destination while browsing cover pages. */
export const COVER_PAGE_CLOSE_TARGET_STATE_KEY = "coverPageCloseTarget"

/** Last-resort close destination when no valid target can be resolved. */
export const DEFAULT_COVER_PAGE_CLOSE_TARGET = "/library/"

export function resolveCoverPageCloseTarget(
  candidate: string | null | undefined,
  excludePath?: string | null
): string {
  return (
    normalizeCloseTargetCandidate(candidate, excludePath) ??
    DEFAULT_COVER_PAGE_CLOSE_TARGET
  )
}

let activeCloseTarget: string | null = null

/** Bridges React closeTarget state to legacy route `closeCoverPage`. */
export function setActiveCoverPageCloseTarget(closeTarget: string | null) {
  activeCloseTarget = closeTarget
}

export function getActiveCoverPageCloseTarget() {
  return activeCloseTarget
}

export function clearActiveCoverPageCloseTarget() {
  activeCloseTarget = null
}

/** Return `url` unless it is empty or matches `excludePath` (e.g. the cover page itself). */
export function normalizeCloseTargetCandidate(
  url: string | null | undefined,
  excludePath: string | null | undefined
): string | null {
  if (!url || pathsEqual(url, excludePath)) return null
  return url
}
